import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class NotificacoesSmsService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'notificacaoSms';
  }

  protected getBaseUrlPublic(): string {
    throw new Error("Método não suportado!");
  }

  procurarLoteNotificacaoSmsPorPk(entityId: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/procurarPorId`, entityId);
  }

  procurarLoteNotificacaoSmsFiltro(filtro: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/filtro`, filtro);
  }

  consultarCreditosSms(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/creditos`);
  }

}
